import { Injectable } from '@angular/core';
declare var $: any;

@Injectable()
export class BlockUi {

    constructor() { }

    block() {
        try {
            $.blockUI({
                // message: '<i class="icon-spinner4 spinner"></i>',
                message: '<span class="font-weight-semibold"><i class="icon-spinner4 spinner mr-2"></i>&nbsp; Aguarde...</span>',
                overlayCSS: {
                    backgroundColor: '#1b2024',
                    opacity: 0.8,
                    cursor: 'wait',
                },
                css: {
                    border: 0,
                    padding: '10px 15px',
                    color: '#fff',
                    '-webkit-border-radius': 3,
                    '-moz-border-radius': 3,
                    backgroundColor: '#333'
                }
            });
        } catch (e) {
            console.error('erro');
        }
    }

    unblock() {
        try {
            $.unblockUI();
        } catch (e) {
            console.error('erro');
        }
    }
}
